module.exports = __webpack_public_path__ + "static/media/8.2bf0df11.jpg";